<style lang="scss">
  @use "../../../../assets/css/_colors" as *;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  $sidebar-width: utils.in_rem(80px);
  $sidebar-width-expanded: 12.5rem;

  .wrapper {
    width: $sidebar-width;
    height: 100vh;

    nav#sidebar {
      @include colors.background-color(primary_50);
      width: $sidebar-width;
      height: 100vh;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 98;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow-x: hidden;
      transition: all 0.1s ease-in-out;

      &:hover {
        width: $sidebar-width-expanded;
      }

      &.isImpersonating {
        background-color: $red;
      }
    }
  }
</style>

<script>
  import ConfirmNavigation from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/ConfirmNavigation.svelte";
  import { cookieValue } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { confirmationStore } from "../../../stores/confirmation-store";
  import BottomNav from "./BottomNav/BottomNav.svelte";
  import TopNav from "./TopNav/TopNav.svelte";

  import { sidebarIsExpanded } from "./stores/sidebar-store.js";
  const isImpersonating = cookieValue("impersonating") === "true";

  const onmouseenter = () => {
    $sidebarIsExpanded = true;
  };

  const onmouseleave = () => {
    $sidebarIsExpanded = false;
  };

  const handleConfirm = () => {
    if ($confirmationStore.onConfirm) {
      $confirmationStore.onConfirm();
    }
    confirmationStore.hide();
  };

  const handleCancel = () => {
    if ($confirmationStore.onCancel) {
      $confirmationStore.onCancel();
    }
    confirmationStore.hide();
  };
</script>

<div class="wrapper">
  <nav
    id="sidebar"
    data-testid="sidebar"
    class:isImpersonating
    {onmouseenter}
    {onmouseleave}
  >
    <TopNav />
    <BottomNav />
  </nav>
</div>

{#if $confirmationStore.show}
  <ConfirmNavigation
    confirmText={$confirmationStore.confirmText}
    cancelText={$confirmationStore.cancelText}
    confirm={handleConfirm}
    cancel={handleCancel}
  >
    {#snippet header()}
      <h4>Sign out</h4>
    {/snippet}
    {$confirmationStore.message}
  </ConfirmNavigation>
{/if}
